import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const InterestFilter = ({
  selectedInterestType,
  setSelectedInterestType,
  groupList,
}: {
  selectedInterestType: number;
  setSelectedInterestType: (value: number) => void;
  groupList: { group_idx: number; group: string }[];
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setIsOpen]);

  const selectedType = groupList.find(
    (group) => group.group_idx === selectedInterestType,
  );

  return (
    <FilterWrapper>
      <Selected onClick={() => setIsOpen((prev) => !prev)}>
        {selectedInterestType === 0 ? '관심 분류 선택' : selectedType?.group}
        <img
          src={
            isOpen
              ? '/assets/images/arrow/black_arrow_up_20.svg'
              : '/assets/images/arrow/black_arrow_down_20.svg'
          }
          alt="up"
          width={16}
          height={16}
        />
      </Selected>
      {isOpen && (
        <Dropdown ref={dropdownRef}>
          <DropdownItem
            onClick={() => {
              setSelectedInterestType(0);
              setIsOpen(false);
            }}
            selected={selectedInterestType === 0}
          >
            전체
            {selectedInterestType === 0 && (
              <img
                src="/assets/images/check/blue_check_32.svg"
                alt="check"
                width={24}
                height={24}
              />
            )}
          </DropdownItem>
          {groupList.map((group) => (
            <DropdownItem
              key={group.group_idx}
              onClick={() => {
                setSelectedInterestType(group.group_idx);
                setIsOpen(false);
              }}
              selected={selectedInterestType === group.group_idx}
            >
              <ItemText>{group.group}</ItemText>
              {selectedInterestType === group.group_idx && (
                <img
                  src="/assets/images/check/blue_check_32.svg"
                  alt="check"
                  width={24}
                  height={24}
                />
              )}
            </DropdownItem>
          ))}
        </Dropdown>
      )}
    </FilterWrapper>
  );
};

export default InterestFilter;

const FilterWrapper = styled.div`
  position: relative;
  margin-left: auto;
`;

const Selected = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  user-select: none;

  font-weight: 500;
  font-size: 14px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #616161;
`;

const Dropdown = styled.div`
  position: absolute;
  top: 26px;
  right: 0;
  z-index: 10;
  width: 200px;
  max-height: 250px;
  overflow-y: auto;
  background: white;
  border-radius: 20px;
  box-shadow: 0px 4px 15px 0px #8d95a340;
  padding: 16px 14px;
`;

const DropdownItem = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 8px;
  cursor: pointer;
  align-items: center;
  border-radius: 8px;

  font-weight: 500;
  font-size: 15px;
  line-height: 145%;
  letter-spacing: -5%;
  color: ${(props) => (props.selected ? '#008AFF' : '#222')};

  &:hover {
    background-color: #0000000a;
  }
`;

const ItemText = styled.span`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 128px;
`;
